import { DOTS } from './constants'

const FIRST_PAGE = 1

const getAllPageNumbers = (lastPage: number) => {
    const allPageNumbers = []
    for (let i = FIRST_PAGE; i <= lastPage; i++) {
        allPageNumbers.push(i)
    }
    return allPageNumbers
}

export const getPaginationList = (
    currentPage: number,
    lastPage: number,
): (typeof DOTS | number)[] => {
    const allPageNumbers = getAllPageNumbers(lastPage)

    if (lastPage < 6) {
        return allPageNumbers
    }

    if (currentPage >= 1 && currentPage <= 3) {
        return [1, 2, 3, 4, DOTS, lastPage]
    }

    if (currentPage === 4) {
        const sliced = allPageNumbers.slice(0, 5)
        if (lastPage > 6) {
            return [...sliced, DOTS, lastPage]
        }
        return [...sliced, lastPage]
    }

    if (currentPage > 4 && currentPage < lastPage - 2) {
        const sliced1 = allPageNumbers.slice(currentPage - 2, currentPage)
        const sliced2 = allPageNumbers.slice(currentPage, currentPage + 1)
        return [1, DOTS, ...sliced1, ...sliced2, DOTS, lastPage]
    }

    if (currentPage > lastPage - 3) {
        const sliced = allPageNumbers.slice(lastPage - 4)
        return [1, DOTS, ...sliced]
    }

    return allPageNumbers
}
